<template>
    <div>
        <div class="modal-container">
            <div class="modal-form-container">
                <div class="modal-content">
                    <div class="task" v-for="(task, key) in tasks" :key="key">
                        <div class="task-name" v-if="task.process" v-text="task.name"></div>
                        <div class="task-status" v-if="task.process"
                            :class="{ 'error': task.status === false, 'success': task.status === true }"
                            v-text="task.message"></div>
                    </div>
                </div>
                <div class="modal-footer">
                    <span v-if="cont"> {{ cont }}</span>
                </div>
                <div class="buttons-container">
                    <DefaultButton v-if="!running" :text="getString('Tentar Novamente')" :outlined="true"
                        @defaultBtnClick="tryAgain()"></DefaultButton>
                    <DefaultButton :text="getString('Recarregar')" :outlined="true" @defaultBtnClick="reload()">
                    </DefaultButton>
                </div>
            </div>
        </div>
        <div class="overlay"></div>
    </div>
</template>

<script>
// import idxdDB from '@/assets/libs/IndexedDBController'
// import md5 from 'md5'
import Util from '@/assets/libs/util'
import requestModule from '@/assets/libs/requestModule'
// import ProductController from '@/assets/controllers/ProductController'
import LocaleController from '@/assets/controllers/LocaleController'
import eventModule from '@/assets/libs/eventModule'
import UpdaterController from '../assets/controllers/UpdaterController'
import DefaultButton from '@/components/DefaultButton'

export default {
    name: 'ConfirmConfigModal',
    components: {
        DefaultButton
    },
    data () {
        return {
            cont: 0,
            error: [],
            tasks: [
                {
                    task: 'checkConectionStatus',
                    name: this.getString('verificar_conexao'),
                    message: this.getString('pendente'),
                    status: null,
                    process: true
                },
                {
                    task: 'syncAllConfigs',
                    name: this.getString('atualizar_informações_caixa'),
                    message: this.getString('pendente'),
                    status: null,
                    process: true
                },
                {
                    task: 'checkParamns',
                    name: this.getString('verificar_params'),
                    message: this.getString('pendente'),
                    status: null,
                    process: true
                },
                {
                    task: 'getTiposRecebimento',
                    name: this.getString('atualizar_recebimentos'),
                    message: this.getString('pendente'),
                    status: null,
                    process: true
                },
                {
                    task: 'updateMenu',
                    name: this.getString('atualizar_cardapio'),
                    message: this.getString('pendente'),
                    status: null,
                    process: true
                },
                {
                    task: 'checkTaxPendingProducts',
                    name: this.getString('verificar_pendencias'),
                    message: this.getString('pendente'),
                    status: null,
                    process: true
                }
            ],
            running: false
        }
    },
    mounted () {
        this.handleTasks()
    },
    props: ['config', 'storedImages'],
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        handleTasks: async function () {
            let hasError = false
            this.running = true
            eventModule.$emit('setCountDownTimeOut', false)
            try {
                for (let i = 0; (i < this.tasks.length); i++) {
                    if (hasError) break
                    if (!this.tasks[i].process) continue
                    this.tasks[i].message = this.getString('processando')
                    let result = await this[this.tasks[i].task]()
                    this.tasks[i].status = result.status || false
                    this.tasks[i].message = result.message || ''
                    if (this.tasks[i].status === false && process.env.NODE_ENV === 'production') {
                        this.running = false
                        hasError = true
                        break
                    }
                }
            } catch (e) {
                this.running = false
                hasError = true
                Util.showInfoModal(e, false)
                Util.logComunication('Exception - confirmconfigmodal', {}, e)
            }
            eventModule.$emit('setCountDownTimeOut', true)

            if (!hasError) {
                this.cont = 3
                while (this.cont > 0) {
                    await this.delay(1)
                    this.cont--
                }
                Util.reloadcachedConfigs()
                this.reload()
            }
            this.running = false
        },
        checkParamns: async function () {
            let result = await UpdaterController.checkParams(this.config)
            if (result) {
                return this.teste(result).then((mensage) => {
                    if (mensage) {
                        Util.showInfoModal(mensage, false)
                        return {
                            error: mensage.length > 0,
                            status: mensage.length === 0,
                            message: !mensage ? this.getString('concluido') : this.getString('falha')
                        }
                    } else {
                        return {
                            error: false,
                            status: true,
                            message: this.getString('concluido')
                        }
                    }
                }).catch((e) => {
                    Util.showInfoModal(e, false)
                    return {
                        error: true,
                        status: false,
                        message: this.getString('falha')
                    }
                })
            }
        },
        teste: async function (result) {
            let mensage = ''
            return new Promise((resolve, reject) => {
                Object.keys(result).forEach(e => {
                    if (result[e]) {
                        this.error.push(...result[e])
                    }
                })
                if (this.error) {
                    this.error.forEach(e => {
                        mensage += (e.error + '<br> <br>' + e.description + '<br>')
                    })
                }
                resolve(mensage)
            })
        },
        checkConectionStatus: async function () {
            const minVersionSupported = process.env.minVersionSupported
            const method = Util.isOracle() ? 'get' : 'post'
            let resultOdhenInterface = await requestModule.postRequest('/', {}, method)
                .then((e) => {
                    if (!e || !e.data) {
                        return {
                            error: true,
                            status: false,
                            message: this.getString('interface_nao_encontrada_404')
                        }
                    }
                    if (e.data && !e.data.connection) {
                        return {
                            error: true,
                            status: false,
                            message: this.getString('interface_sem_conexao')
                        }
                    }
                    return {
                        error: false,
                        status: true,
                        message: `${this.getString('versao_interface')} ${e.data.version}`,
                        version: e.data.version
                    }
                })
                .catch((e) => {
                    return {
                        error: true,
                        message: this.getString('interface_nao_encontrada_404')
                    }
                })
            let message = resultOdhenInterface.message
            if (resultOdhenInterface.error) {
                return {
                    status: false,
                    message: message
                }
            }
            let interfaceVersionIsSupported = Util.interfaceVersionIsSupported(resultOdhenInterface.version, minVersionSupported)
            if (!interfaceVersionIsSupported) {
                let statusVersion = this.getString('versao_interface') + `(${resultOdhenInterface.version})` +
                    this.getString('incompativel_com_o_TAA_necessario_versao') + minVersionSupported +
                    this.getString('ou_superior')
                return {
                    status: false,
                    message: statusVersion
                }
            }
            return {
                status: true,
                message: message
            }
        },
        getTiposRecebimento: async function () {
            const result = await UpdaterController.updatePaymentsTypes(this.config)
            return {
                status: result,
                message: result ? this.getString('concluido') : this.getString('falha')
            }
        },
        checkTaxPendingProducts: async function () {
            const result = await UpdaterController.checkTaxPendingProducts()

            if (!result.hasPending) {
                return { status: true, message: this.getString('concluido') }
            }

            this.$emit('openTaxModal', result.data)

            await new Promise(resolve => {
                this.$once('taxModalClosed', resolve)
            })

            return { status: true, message: this.getString('concluido') }
        },
        delay: function (seconds) {
            return new Promise(function (resolve) {
                setTimeout(resolve, seconds * 1000)
            })
        },
        setPosConfig: async function () {
            let configToSave = Util.deepCopy(this.config)

            // O configToSave.caixaCodigo não pode ser deletado, porque o backend vai usar para saber em que pasta
            // colocar esse arquivo de config
            delete configToSave.nomeDoDispositivo
            delete configToSave.storeCNPJ
            delete configToSave.enderecoIPTEF
            delete configToSave.codigoTerminalTEF
            delete configToSave.codLojaTEF
            delete configToSave.sendingCupEmail
            delete configToSave.curtaa
            delete configToSave.metodosPagamento
            delete configToSave.tiposRecebimento
            delete configToSave.taas
            if (!Util.isOracle()) {
                await requestModule.postRequest('setPosConfig', { config: configToSave, device: 'TAA' })
            }
        },
        updateMenu: async function () {
            let handleTask = true
            if (process.env.NODE_ENV !== 'production') {
                await Util.showConfirmationDialogSync(null, () => {
                    handleTask = true
                }, 'Atualizar cardápio?', () => {
                    handleTask = false
                })
            }
            let result = true
            if (handleTask) {
                result = await UpdaterController.updateMenu(true, this.config)
                Util.updateLastSync()
            }
            if (result) {
                result = await UpdaterController.updateNewSuggestions(true)
            }
            return {
                status: result,
                message: result ? this.getString('concluido') : this.getString('falha')
            }
        },
        syncAllConfigs: async function () {
            const result = await UpdaterController.updatePosConf(this.config)
            return {
                status: result,
                message: result ? this.getString('concluido') : this.getString('falha')
            }
        },
        tryAgain: function () {
            this.tasks.forEach((e) => {
                e.message = this.getString('pendente')
                e.status = null
            })
            this.handleTasks()
        },
        reload: function () {
            window.location.reload()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 120px;
    background: @white;
    border-radius: 25px;
    z-index: 20;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    padding-bottom: 40px;
    height: max-content;

    .modal-form-container {
        position: relative;
        overflow: hidden auto;

        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;
            margin-bottom: 15px;

            h2 {
                color: @white;
                margin: auto;
            }
        }

        .modal-content {
            margin: 100px 50px;

            .task {
                display: grid;
                grid-template-columns: auto auto;
                padding-bottom: 20px;

                .task-status {
                    text-align: end;
                }

                .task-status {
                    &.error {
                        color: red;
                    }

                    &.success {
                        color: green;
                    }
                }
            }
        }

        .modal-footer {
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                font-size: 2ch;
                text-align: center;
            }
        }

        .buttons-container {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-evenly;
            align-items: center;
        }
    }

    .overlay {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 1;
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .modal-container {
        margin: auto 30px;
        height: max-content;

        .modal-form-container {
            .modal-content {
                margin: 40px;
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    //@tablet

    .modal-container {
        margin: auto 50px;
        height: max-content;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmConfigModal.vue